export default __webpack_public_path__ + "static/media/star_on.ab63b417.svg";